/* eslint-disable react/jsx-props-no-spreading */
import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import { useMemo } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useLocation } from 'wouter';

import { useThemeClassName } from '../../contexts/ThemeContext';
import SubmitButton from '../buttons/SubmitButton';
// import * as AppPropTypes from '../../lib/PropTypes';
import PageMeta from '../meta/PageMeta';
import PageTitle from '../partials/PageTitle';

import styles from '../../../styles/pages/error.module.scss';

export const messages = defineMessages({
    metaTitle401: {
        defaultMessage: 'Access forbidden',
        description: 'Error page meta title',
    },
    title401: {
        defaultMessage: 'Access forbidden',
        description: 'Error page title',
    },
    description401: {
        defaultMessage: 'You must be logged in to acces this page.',
        description: 'Error page description',
    },

    metaTitle403: {
        defaultMessage: 'Not authorized',
        description: 'Error page meta title',
    },
    title403: {
        defaultMessage: 'Not authorized',
        description: 'Error page title',
    },
    description403: {
        defaultMessage: 'You are not authorized to access this page.',
        description: 'Error page description',
    },

    metaTitle404: {
        defaultMessage: 'Page not found',
        description: 'Error page meta title',
    },
    title404: {
        defaultMessage: 'Page not found',
        description: 'Error page title',
    },
    description404: {
        defaultMessage: 'This page doesn’t exist or has been moved',
        description: 'Error page description',
    },

    metaTitle500: {
        defaultMessage: 'Server error',
        description: 'Error page meta title',
    },
    title500: {
        defaultMessage: 'Server error',
        description: 'Error page title',
    },
    description500: {
        defaultMessage: 'There was an error, the admin have been notified',
        description: 'Error page description',
    },

    gotoHome: {
        defaultMessage: 'Go to home',
        description: 'Button label',
    },
});

function ErrorPage({ statusCode = 404 }: { statusCode: number }) {
    const themeClassName = useThemeClassName(styles);
    const url = useUrlGenerator();
    const page = useMemo(() => ({ title: messages[`metaTitle${statusCode || 404}`] }), []);
    const { title } = page;

    return (
        <div className={classNames([styles.container, themeClassName])}>
            <PageMeta page={page} />
            <div className={styles.inner}>
                <PageTitle className={styles.title} title={title} />
                <p className={styles.description}>
                    <FormattedMessage {...messages[`description${statusCode || 404}`]} />
                </p>
                <div className={styles.actions}>
                    <SubmitButton
                        href={url('home')}
                        className={styles.button}
                        external
                        target="_self"
                    >
                        <FormattedMessage {...messages.gotoHome} />
                    </SubmitButton>
                </div>
            </div>
        </div>
    );
}

export default ErrorPage;
